import * as React from 'react';
import { space } from '@workday/canvas-kit-react/tokens';
import { ErrorType, styled, generateUniqueId, } from '@workday/canvas-kit-react/common';
import { Hint } from './Hint';
import { Label } from './Label';
import { FormFieldLabelPosition } from './types';
// Use a fieldset element for accessible radio groups
const FormFieldFieldsetContainer = styled('fieldset')(({ grow, labelPosition }) => ({
    display: labelPosition === FormFieldLabelPosition.Top ? 'inline-block' : 'flex',
    flexGrow: grow ? 1 : undefined,
    padding: 0,
    border: 0,
    margin: 0,
    marginBottom: space.m,
}));
const FormFieldContainer = styled('div')(({ labelPosition, useFieldset }) => {
    if (useFieldset) {
        return {
            display: 'flex',
        };
    }
    if (labelPosition === FormFieldLabelPosition.Left) {
        return {
            display: 'flex',
            marginBottom: space.m,
        };
    }
    return {
        display: 'block',
        marginBottom: space.m,
    };
});
const FormFieldInputContainer = styled('div')(({ grow, labelPosition }) => {
    if (grow) {
        if (labelPosition === FormFieldLabelPosition.Left ||
            labelPosition === FormFieldLabelPosition.Hidden) {
            return {
                flexGrow: 1,
            };
        }
        return {
            width: '100%',
            display: 'block',
        };
    }
    if (labelPosition === FormFieldLabelPosition.Left) {
        return {
            display: 'inline-flex',
            alignItems: 'center',
            flexWrap: 'wrap',
        };
    }
    return {
        display: 'inline-block',
    };
});
export class FormField extends React.Component {
    constructor() {
        super(...arguments);
        this.inputId = this.props.inputId || generateUniqueId();
        this.renderChildren = (child) => {
            if (React.isValidElement(child)) {
                const props = {
                    ...child.props,
                };
                if (this.props.grow) {
                    props.grow = this.props.grow;
                }
                if (typeof this.props.error !== 'undefined') {
                    props.error = this.props.error;
                    if (this.props.error === ErrorType.Error) {
                        props['aria-invalid'] = true;
                    }
                }
                if (this.props.hintId) {
                    props['aria-describedby'] = this.props.hintId;
                }
                if (this.props.required) {
                    props.required = true;
                }
                props.id = this.inputId;
                return React.cloneElement(child, props);
            }
            return child;
        };
    }
    render() {
        const { errorLabel = 'Error', alertLabel = 'Alert', useFieldset = false, labelPosition = FormField.LabelPosition.Top, label, hintText, hintId, inputId, grow, children, error, required, ...elemProps } = this.props;
        const field = (React.createElement(React.Fragment, null,
            typeof label === 'string' ? (React.createElement(Label, { labelPosition: labelPosition, htmlFor: this.inputId, isLegend: useFieldset, required: required, accessibleHide: labelPosition === FormFieldLabelPosition.Hidden }, label)) : (label),
            React.createElement(FormFieldInputContainer, { grow: grow, labelPosition: labelPosition },
                React.Children.map(children, this.renderChildren),
                hintText && (React.createElement(Hint, { errorLabel: errorLabel, alertLabel: alertLabel, error: error, id: hintId }, hintText)))));
        if (useFieldset) {
            return (React.createElement(FormFieldContainer, Object.assign({ useFieldset: useFieldset, labelPosition: labelPosition }, elemProps),
                React.createElement(FormFieldFieldsetContainer, { grow: grow, labelPosition: labelPosition }, field)));
        }
        else {
            return (React.createElement(FormFieldContainer, Object.assign({ useFieldset: useFieldset, labelPosition: labelPosition }, elemProps), field));
        }
    }
}
FormField.LabelPosition = FormFieldLabelPosition;
FormField.ErrorType = ErrorType;
FormField.LabelPosition = FormFieldLabelPosition;
FormField.ErrorType = ErrorType;
